<template>
  <AdminLayout>
    <Head title="Pickup Orders" />

    <template #pageTitle> Pick-Up </template>

    <template #headingOptions> </template>

    <!-- Form -->
    <button @click="onSimulateScan">Simulate Barcode Scan</button>
  </AdminLayout>
</template>

<script setup>
import { onMounted, onUnmounted } from 'vue'
import onScan from 'onscan.js/onscan.min'

console.log(onScan)

const onSimulateScan = () => {
  // By default a minimum of 6 chars is considered a scan.
  // onScan.simulate(document, [48,49,50,48,49,48]);

  onScan.simulate(document, '1234567890123')

  // const event = new CustomEvent('scan', { detail: {scancode: '1234567890', quantity: 1} });
  // document.dispatchEvent(event);
}

onMounted(() => {
  // @Todo: onScanError

  onScan.attachTo(document, {
    onScan: function (sCode, iQty) {
      // Alternative to document.addEventListener('scan')
      console.log('Scanned: ' + iQty + 'x ' + sCode)
    }
    // onKeyDetect(iKeyCode, oEvent) {
    //   console.log(iKeyCode, oEvent);
    // }
  })

  // document.addEventListener('scan', (e) => {
  //   console.log('Code: ', e.detail.scanCode);
  //   console.log('Qty: ', e.detail.qty);
  // });

  //ScanError
  // document.addEventListener('scan-error', (e) => {
  //   console.log('Error: ', e.detail.error);
  // });
  //
  // document.addEventListener('scan-start', (e) => {
  //   console.log('Scan Start');
  // });
  //
  // document.addEventListener('keyDetect', (e) => {
  //   console.log('Key Detect', e);
  // })
})

onUnmounted(() => {
  // @Todo: remove event handlers.
  onScan.detachFrom(document)
})
</script>

<script>
import AdminLayout from '@/Layouts/AdminLayout.vue'
import { ChevronDownIcon } from '@heroicons/vue/solid'
import { Head, Link } from '@inertiajs/vue3'
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'

export default {
  components: {
    Link,
    AdminLayout,
    Head,
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    ChevronDownIcon
  }
}
</script>
